import { Org } from 'modules/Org/Org'
import { TankLevelCalibration } from 'modules/TankLevelCalibration/TankLevelCalibration'
import { Tenant } from 'modules/Tenant/Tenant'
import { Model } from 'pinia-orm'
import { Attr, Uid, BelongsTo } from 'pinia-orm/dist/decorators'

export class TankLevelNode extends Model {
  static override entity = 'tank_level_nodes'

  // Fields
  @Uid() declare id: string

  @Attr() declare sensor_adc: number | null
  @Attr() declare sensor_ma: number | null
  @Attr() declare height_mm: number | null
  @Attr() declare litres: number | null
  @Attr() declare tags: null | string
  @Attr() declare notes: null | string

  // Relationships
  @Attr(null) declare tank_level_calibration_id: string | null
  @BelongsTo(() => TankLevelCalibration, 'tank_level_calibration_id') declare tank_level_calibration: TankLevelCalibration | null

  @Attr(null) declare tenant_id: string
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null

  @Attr(null) declare org_id: string
  @BelongsTo(() => Tenant, 'org_id') declare org: Org | null
}
